import { z } from 'zod'

export const contactSchema = z.object({
  name: z
    .string()
    .min(1, 'Name is required.')
    .max(100, 'Name must be 100 characters or less'),
  email: z
    .string()
    .min(1, 'Email is required.')
    .email('Please enter a valid email.'),
  company: z
    .string()
    .max(100, 'Company must be 100 characters or less')
    .optional()
    .transform((val) => val?.trim() || undefined),
  phone: z
    .string()
    .max(20, 'Phone number must be 20 characters or less')
    .optional()
    .transform((val) => val?.trim() || undefined),
  partInquiry: z
    .string()
    .max(200, 'Part inquiry must be 200 characters or less')
    .optional()
    .transform((val) => val?.trim() || undefined),
  message: z
    .string()
    .min(1, 'Message is required.')
    .max(2000, 'Message must be 2000 characters or less'),
})

export type ContactFormInput = z.input<typeof contactSchema>
export type ContactFormData = z.infer<typeof contactSchema>
